/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { paymetric } from 'services/Paymetric'
import { ALERTS } from 'constants/alerts'
import { createAlert, onShowError } from 'redux-app/modules/alerts'
import { updatePaymentDetails, verifyCurrentCard } from 'api/client/actions/card'
import { getPaymetricAccessToken } from 'api/client/actions/paymetric'
import { resendConfirmEmail, getShippingHistory, getPaymentHistory } from 'api/client/actions/user'

export const onRequestToPaymetric = (formValues, captcha) => dispatch => {
  return dispatch(getPaymetricAccessToken(captcha)).then(async ({ value: { result } }) => {
    const { accessToken, merchantId } = result
    const { paymentCreditCard, expMonth, expYear, CVV } = formValues
    const paymetricResponse = await paymetric.submit({
      accessToken,
      merchantGuid: merchantId,
      paymentCreditCard,
      expMonth,
      expYear,
      CVV,
    })

    if (paymetricResponse.success) {
      return Promise.resolve(result)
    }

    dispatch(createAlert({
      name: ALERTS.paymetricError,
    }))

    return Promise.reject()
  })
}

export const onUpdatePaymentDetails = data => dispatch => {
  return dispatch(updatePaymentDetails(data))
}

export const onVerifyCurrentCard = data => dispatch => {
  return dispatch(verifyCurrentCard())
}

export const onResendConfirmEmail = () => dispatch => {
  return dispatch(resendConfirmEmail())
    .then(() => {
      dispatch(createAlert({
        name: ALERTS.successResendConfirmEmail,
      }))
    })
    .catch(error => {
      dispatch(onShowError(error))
    })
}

export const onGetShippingHistory = () => dispatch => {
  return dispatch(getShippingHistory())
    .catch((error: any) => {
      dispatch(onShowError(error, {}))
      throw error
    })
}

export const onGetPaymentHistory = () => dispatch => {
  return dispatch(getPaymentHistory())
    .catch((error: any) => {
      dispatch(onShowError(error, {}))
      throw error
    })
}
